import { render, staticRenderFns } from "./DebouncedButton.vue?vue&type=template&id=65d44ad6&"
import script from "./DebouncedButton.vue?vue&type=script&lang=js&"
export * from "./DebouncedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports